const SessionData = (() => {
    let data = {};
    
    if (typeof sessionStorage !== 'undefined') {
        const brwsDataJSON = sessionStorage.getItem('_kpData');
        const brwsData = JSON.parse(brwsDataJSON);
        if (brwsData) {
            data = brwsData;
        }
    }
  
    const getValue = (key) => {
        let returnValue = null;

        if (data && key in data) {
            returnValue = data[key];
        }

        return returnValue;
    };
  
    const setValue = (key, value) => {
        data[key] = value;

        if (typeof sessionStorage !== 'undefined') {
            sessionStorage.setItem('_kpData', JSON.stringify(data));
        }
    };
  
    return {
        getValue: getValue,
        setValue: setValue
    }
  
  })();
  
  export default SessionData;